import { Widget } from '@typeform/embed-react';
import Image from 'next/image';
import { ReactNode, useState } from 'react';
import ReactModal from 'react-modal';
import { useMedia } from 'react-use';

import { OTCAddress } from '@endaoment-frontend/types';
import { CopyIcon, EthereumIcon } from '@endaoment-frontend/ui/icons';
import { Button } from '@endaoment-frontend/ui/shared';
import { getShortAddress } from '@endaoment-frontend/utils';

import styles from './TypeformButton.module.scss';

const ModalOTCInfo = ({ logoURI, name, symbol, memo, address }: OTCAddress) => {
  const isMobile = useMedia('(max-width: 40rem)', true);
  return (
    <div className={styles['otc-info']}>
      <div className={styles['otc-name']}>
        {logoURI ? <Image src={logoURI} alt={name} width={38} height={38} /> : <EthereumIcon width={38} height={38} />}
        <span>
          {name}
          <b>{symbol && ` (${symbol.toUpperCase()})`}</b>
        </span>
      </div>
      <div className={styles['otc-memo']}>
        <span>{isMobile ? '' : getShortAddress(address)}</span>
        <CopyIcon
          onClick={() => {
            navigator.clipboard.writeText(memo);
          }}
        />
      </div>
      <div className={styles['otc-address']}>
        <span>{isMobile ? '' : getShortAddress(address)}</span>
        <CopyIcon
          onClick={() => {
            navigator.clipboard.writeText(address);
          }}
        />
      </div>
    </div>
  );
};

export const TypeformButton = ({
  children,
  otcAddress,
  className,
  small,
}: {
  children: ReactNode;
  otcAddress?: OTCAddress;
  className?: string;
  small?: boolean;
}) => {
  const [showForm, setShowForm] = useState(false);
  return (
    <>
      <Button
        onClick={() => {
          setShowForm(true);
        }}
        className={className}
        size={small ? 'small' : 'medium'}
      >
        {children}
      </Button>
      <ReactModal
        className={styles['typeform-modal']}
        overlayClassName={styles['modal-overlay']}
        isOpen={showForm}
        onRequestClose={() => {
          setShowForm(false);
        }}
      >
        <Widget id="IWxBhuMP" inlineOnMobile className={styles['typeform-iframe']} />
        {otcAddress && <ModalOTCInfo {...otcAddress} />}
      </ReactModal>
    </>
  );
};
